export class RouteParams {
  getParam(params: object, paramName: string) {
    return params[paramName] || null;
  }
}
